import axios from 'axios';
import applyCaseMiddleware from 'axios-case-converter';
import Swal from 'sweetalert2';
import { logout } from './AuthApi';

export const USUARIO_KEY = '@usuario_key';
export const ID_MEMBRO_KEY = 'ID_MEMBRO';

export const TOKEN_KEY = '@airbnb-Token';

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getUsuario = () =>
    !!localStorage.getItem(USUARIO_KEY)
        ? localStorage.getItem(USUARIO_KEY)
        : '';

export const getIdMembro = () =>
    !!localStorage.getItem(ID_MEMBRO_KEY)
        ? localStorage.getItem(ID_MEMBRO_KEY)
        : '';

export const setToken = token => {
    localStorage.setItem(TOKEN_KEY, token);
};

export const persistUsuario = usuario => {
    localStorage.setItem(USUARIO_KEY, usuario);
};

export const persistIdMembro = idMembro => {
    localStorage.setItem(ID_MEMBRO_KEY, idMembro);
};

export const removerUsuario = lembrar => {
    localStorage.removeItem(USUARIO_KEY);
    localStorage.removeItem(ID_MEMBRO_KEY);
};

const api = applyCaseMiddleware(
    axios.create({
        baseURL: 'https://cadastro-api.nib.org.br/v2',
    })
);

api.interceptors.request.use(async config => {
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// api.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

api.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        if (
            error.response.status === 401 &&
            error.response.data.message === 'Unauthenticated.'
        ) {
            new Swal({
                title: 'Sessão Expirada',
                text:
                    'A validade da sua sessão de login expirou. Podemos redirecioná-lo para a tela de login agora?',
                confirmButtonColor: '#33691E',
                confirmButtonText: 'OK',
                closeOnConfirm: false,
            }).then(result => {
                logout();
                window.location.replace(`/login`);
            });
        }
        return Promise.reject(error);
    }
);

export default api;
